module.exports = __webpack_public_path__ + "img/olc-screen-olc-6.06d2e531.jpg";